module.exports = __webpack_public_path__ + "img/pf.pfbe30b55.svg";